import { ProcessingResult } from '@/components/HomePageModule/ProcessingResult'
import { logger, LogTag } from '@/config/logger'
import Cookies from 'js-cookie'

// Debug results
import debugTimeAnalysisData from '@/test/da_brat_time_analysis.json'
//import debugTimeAnalysisData from '.@/test/Thumping_Underground_SunoV4_time_analysis_vocals.json'

export const AiMusicDetectorCookie = {
  AiProbability: 'aim_detector_aiProbability',
  FileName: 'aim_detector_file',
  IasUrl: 'aim_detector_ias',
  JobId: 'aim_detector_job_id',
  ProcessingIsoDate: 'aim_detector_date',
  Status: 'aim_detector_status',
  SuspectedModel: 'aim_detector_model',
  TimeAnalysis: 'aim_detector_time_analysis',
}

export class AiMusicDetectorResult extends ProcessingResult {
  aiProbability: number | undefined
  modelVersion: string | undefined
  status: string | undefined
  suspectedModel: string | undefined
  timeAnalysis: any

  constructor(data?: {
    aiProbability?: number
    inputFileName?: string
    jobId?: string
    iasUrl?: string
    processingIsoDate?: string
    suspectedModel?: string
    modelVersion?: string
    status?: string
    userId?: string
    timeAnalysis?: any
  }) {
    super({
      fileName: data?.inputFileName,
      jobId: data?.jobId,
      processingIsoDate: data?.processingIsoDate,
      userId: data?.userId,
    })

    this.aiProbability = data?.aiProbability
    this.suspectedModel = data?.suspectedModel
    this.modelVersion = data?.modelVersion
    this.status = data?.status
    this.timeAnalysis = data?.timeAnalysis
  }

  isComplete() {
    return undefined != this.aiProbability
  }

  hasProcessingJob() {
    return this.jobId != undefined
  }

  getSavedJobId() {
    return Cookies.get(AiMusicDetectorCookie.JobId)
  }

  save() {
    super.save()
    super.setOrRemoveCookie(
      AiMusicDetectorCookie.AiProbability,
      this.aiProbability
    )
    super.setOrRemoveCookie(AiMusicDetectorCookie.FileName, this.fileName)
    super.setOrRemoveCookie(AiMusicDetectorCookie.IasUrl, this.iasUrl)
    super.setOrRemoveCookie(AiMusicDetectorCookie.Status, this.status)
    super.setOrRemoveCookie(AiMusicDetectorCookie.JobId, this.jobId)
    super.setOrRemoveCookie(
      AiMusicDetectorCookie.ProcessingIsoDate,
      this.processingIsoDate
    )
    super.setOrRemoveCookie(
      AiMusicDetectorCookie.SuspectedModel,
      this.suspectedModel
    )
    super.setOrRemoveCookie(
      AiMusicDetectorCookie.TimeAnalysis,
      encodeURIComponent(JSON.stringify(this.timeAnalysis))
    )
  }

  load() {
    super.load()
    this.aiProbability = Cookies.get(AiMusicDetectorCookie.AiProbability)
      ? parseFloat(Cookies.get(AiMusicDetectorCookie.AiProbability)!)
      : undefined

    this.iasUrl = Cookies.get(AiMusicDetectorCookie.IasUrl)

    this.status = Cookies.get(AiMusicDetectorCookie.Status)

    this.jobId = Cookies.get(AiMusicDetectorCookie.JobId)
    this.fileName = Cookies.get(AiMusicDetectorCookie.FileName)
    this.processingIsoDate = Cookies.get(
      AiMusicDetectorCookie.ProcessingIsoDate
    )
    this.suspectedModel = Cookies.get(AiMusicDetectorCookie.SuspectedModel)
    const strTimeAnalysis = Cookies.get(AiMusicDetectorCookie.TimeAnalysis)
    if (typeof strTimeAnalysis == 'string' && strTimeAnalysis != 'undefined') {
      try {
        this.timeAnalysis = JSON.parse(decodeURIComponent(strTimeAnalysis))
      } catch (e) {
        logger.error(
          LogTag.HomePage,
          'Error when loading stringified JSON for timeAnalysis:',
          e
        )
        logger.error(
          LogTag.HomePage,
          'TimeAnalysis data in cookies:',
          strTimeAnalysis
        )
      }
    }
  }

  static cleanSavedData() {
    super.cleanSavedData()
    Cookies.remove(AiMusicDetectorCookie.AiProbability)
    Cookies.remove(AiMusicDetectorCookie.FileName)
    Cookies.remove(AiMusicDetectorCookie.IasUrl)
    Cookies.remove(AiMusicDetectorCookie.JobId)
    Cookies.remove(AiMusicDetectorCookie.ProcessingIsoDate)
    Cookies.remove(AiMusicDetectorCookie.Status)
    Cookies.remove(AiMusicDetectorCookie.SuspectedModel)
    Cookies.remove(AiMusicDetectorCookie.TimeAnalysis)
  }

  setDebugData() {
    super.setDebugData()
    this.aiProbability = 50
    this.timeAnalysis = debugTimeAnalysisData
  }
}
